<template>
  <slot></slot>
</template>

<script setup lang="ts">
import { onMounted } from 'vue';
import { useI18n } from 'vue-i18n';

try {
  const i18n = useI18n();

  onMounted(() => {
    const html = document.getElementsByTagName("html");

    if (html.length && html[0].lang) {
      i18n.locale.value = html[0].lang
    }
  })
} catch {
  console.warn("Could not set language!");
}
</script>